import { rgba } from 'polished';
import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const CompanyOptionsTitle = styled.span`
  align-self: flex-start;
  margin-bottom: 5px;
`;

export const CompanyDetails = styled.button<{ color: string; isActive: boolean }>`
  height: 50px;
  min-width: 325px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-left: 0.75rem;
  background-color: ${({ isActive }) => (isActive ? COLOR.WHITE : COLOR.GREY_WHITE)};
  border: 1px solid #2f384033;
  border-radius: 3px;
  cursor: ${({ isActive }) => (isActive ? `pointer` : `not-allowed`)};
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  &:hover {
    ${({ isActive, color }) => isActive && `border-color: ${`${rgba(color, 0.7)}`};`}
  }
`;
